export interface SchematicLegendItem {
  type: string;
  symbol: string;
  color: string;
}

export interface InstantiatedEquipmentItem {
  id: number;
  name: string;
  iconCode: string;
  acLineType: 'Incoming' | 'Outgoing' | null;
  destinationSubstationCount: number | null;
  terminals: { connectivityNodeId: number | null; sequenceNumber: number | null }[];
}

export interface SchematicNodeDataIn {
  gojsKey: string;
  iconCode: string;
  label: string | null;
  cimEquipmentId: number | null;
  sourceAcLineId: number | null;
  isClosed: boolean | null;
  scale: number;
  length: number | null;
  colorCode: string | null;
  coordinateX: string | null;
  coordinateY: string | null;
  labelCoordinateX: string | null;
  labelCoordinateY: string | null;
  angle: number | null;
  labelAngle: number | null;
}

export interface SchematicEdgeDataIn {
  sourceGojsKey: string;
  destinationGojsKey: string;
  colorCode: string | null;
  fromPort: string | null;
  toPort: string | null;
  busbarFrom: number | null;
  busbarTo: number | null;
}

export interface SchematicSaveRequest {
  substationId: number | null;
  nodes: SchematicNodeDataIn[];
  edges: SchematicEdgeDataIn[];
  expectedLastUpdateTime: string | null;
}

export interface SchematicNodeDataOut {
  id: number;
  iconCode: string | null;
  label: string | null;
  cimEquipmentId: number | null;
  sourceAcLineId: number | null;
  isClosed: boolean | null;
  scale: number;
  length: number | null;
  colorCode: string | null;
  coordinateX: string | null;
  coordinateY: string | null;
  labelCoordinateX: string | null;
  labelCoordinateY: string | null;
  angle: number | null;
  labelAngle: number | null;
}

export interface SchematicEdgeDataOut {
  id: number;
  sourceNodeId: number;
  destinationNodeId: number;
  colorCode: string | null;
  fromPort: string | null;
  toPort: string | null;
  busbarFrom: number | null;
  busbarTo: number | null;
}

export interface SchematicDataOut {
  id: number;
  substationId: number;
  status: number;
  nodes: SchematicNodeDataOut[];
  edges: SchematicEdgeDataOut[];
  lastUpdateTime: string | null;
}

export interface SchematicNodeKeyMap {
  gojsKey: string;
  dbId: number;
}

export interface SchematicSaveDataOut {
  status: number;
  nodeMappings: SchematicNodeKeyMap[];
  lastUpdateTime: string | null;
}

export interface SchematicValidationNodeDataIn {
  key: string;
  cimEquipmentId: number | null;
  sourceAcLineId: number | null;
  name: string | null;
  type: string;
}

export interface SchematicValidationDataIn {
  substationId: number;
  nodes: SchematicValidationNodeDataIn[];
}

// String values because the WebApp serializes enums by name (JsonStringEnumConverter).
export enum SchematicValidationSeverity {
  Error = 'Error',
  Info = 'Info',
}

export interface SchematicValidationIssue {
  nodeKey: string | null;
  message: string;
  severity: SchematicValidationSeverity;
  cimName: string | null;
}